// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5782":"90f32124","9388":"331980fe"}[chunkId] + ".chunk.css";
};